module.exports = __webpack_public_path__ + "static/media/loader.fea523d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/coupon/images/loader.svg
// module id = 1567
// module chunks = 0